import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../Context/BettingContext';
import { __, wait, decode, encode, forceSatoshiFormat, sendNotfication } from "../../../../../Helper";
import storage from "../../../../../Storage";
import C from "../../../../../Constant";
import socket from "../../../../../Socket";
const Container = styled.div`
  width: 100%;
  background: #292d2e;
  margin-left: 3px;
`;

const Header = styled.div`
  background: rgb(50, 55, 56);
  color: rgb(240, 156, 6);
  padding: 13.25px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  border-bottom: 1px solid rgb(240, 156, 6);
`;

const SubHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  background: rgb(50, 55, 56);
  padding: 6px 8px;
  border-bottom: 1px solid rgb(240, 156, 6);
  font-weight: 500;
  color: #ffffff;
  font-size: 11px;
`;

const MatchTitle = styled.div`
  padding: 6px 8px;
  background: ${(props) =>
    props.type === "lay" ? "lightpink" : "lightblue"};
  display: flex;
  align-items: center;
  gap: 6px;
  color: #292d2e;  /* better contrast on light backgrounds */
  font-size: 11px;
  font-weight: 600;
  border-bottom: 1px solid rgb(50, 55, 56);
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  background: rgb(240, 156, 6);
  border-radius: 50%;
  display: inline-block;
`;

const BetRowContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 6px 8px;
  background: #292d2e;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid rgb(50, 55, 56);
`;


const BetRowContainerBlue = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 6px 8px;
  background: #292d2e;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid rgb(50, 55, 56);
`;

const TeamSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CloseIcon = styled.span`
  color: rgb(240, 156, 6);
  margin-right: 3px;
  cursor: pointer;
  font-size: 12px;
`;

const TeamName = styled.span`
  margin-right: 3px;
  font-size: 10px !important;
  color: #ffffff;
`;

const MatchOdds = styled.span`
  color: #ffffff;
  font-size: 0.8em;
`;

const OddsInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 4px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 3px;
  text-align: right;
  font-size: 0.8em;
  outline: none;
  color: #ffffff;
  background: rgb(50, 55, 56);
  &:focus {
    border-color: rgb(240, 156, 6);
  }
`;

const ArrowsContainer = styled.div`
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Arrow = styled.span`
  cursor: pointer;
  font-size: 8px;
  color: rgb(240, 156, 6);
  line-height: 1;
  &:hover {
    color: #ffffff;
  }
`;

const LiabilityValue = styled.div`
  text-align: right;
  padding: 4px 6px;
  background: rgb(50, 55, 56);
  border: 1px solid rgb(240, 156, 6);
  border-radius: 3px;
  min-width: 30px;
  color: rgb(240, 156, 6);
  font-weight: 500;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.8em;
`;

const QuickStakeButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  padding: 6px 8px;
  background: #292d2e;
`;
const QuickStakeButtonsBlue = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  padding: 6px 8px;
  background: #292d2e;
`;


const StakeButton = styled.div`
  padding: 4px;
  background: rgb(50, 55, 56);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(240, 156, 6);
  color: #ffffff;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.8em;
  &:hover {
    background: rgb(60, 65, 66);
  }
`;

const Footer = styled.div`
  padding: 6px 8px;
  background: #292d2e;
`;
const FooterBlue = styled.div`
  padding: 6px 8px;
  background: #292d2e
`;


const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 6px;
`;

const Button = styled.button`
  padding: 6px 8px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.8em;
  
  ${props => props.primary ? `
    background: rgb(240, 156, 6);
    color: #292d2e;
    &:hover {
      background: rgb(220, 136, 6);
    }
  ` : `
    background: rgb(50, 55, 56);
    border: 1px solid rgb(240, 156, 6);
    color: #ffffff;
    &:hover {
      background: rgb(60, 65, 66);
    }
  `}

  ${props => props.disabled ? `opacity: 0.6; cursor: not-allowed;` : ''}
`;

const Button1 = styled.div`
  padding: 10px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  font-size: 0.85em;
  
  ${props => props.primary ? `
    background: rgb(240, 156, 6);
    color: #292d2e;
    &:hover {
      background: rgb(220, 136, 6);
    }
  ` : `
    background: rgb(50, 55, 56);
    border: 1px solid rgb(240, 156, 6);
    color: #ffffff;
    &:hover {
      background: rgb(60, 65, 66);
    }
  `}
`;

const BetConfirm = styled.div`
  padding: 6px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  font-size: 11px;
  
  span {
    color: #ffffff;
  }
`;

const MinBetText = styled.div`
  text-align: right;
  padding: 3px;
  color: #ffffff;
  font-size: 10px;
`;

const LiabilityText = styled.div`
  text-align: right;
  padding: 3px;
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  color: rgb(240, 156, 6);
  font-size: 11px;
  font-weight: bold;
`;

const BetSlip = () => {
  const [betsState, setBetsState] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(true);
  const { selectedBets, removeBet, placeBets, updateBetStake, updateBetOdds } = useBetting();
  const [totalLiability, setTotalLiability] = useState(0);
  const [selectedCoin, setSelectedCoin] = useState(storage.getKey('coin') || "INR");

   const MIN_STAKE = 100;
  const MAX_STAKE = 100000;
  // NEW: lock to prevent multiple concurrent placements
  const [isPlacing, setIsPlacing] = useState(false);

  useEffect(() => {
    const token = storage.getKey('token');

    if (token) {
      socket.emit(C.CREDIT, encode({ token, coin: selectedCoin }));
    }

    const handleCreditData = (data) => handleCredit(decode(data));
    const handleCreditDataUpdate = (data) => handleCreditUpdate(decode(data));

    socket.on(C.CREDIT, handleCreditData);
    socket.on(C.UPDATE_CREDIT, handleCreditDataUpdate);

    return () => {
      socket.off(C.CREDIT, handleCreditData);
      socket.off(C.UPDATE_CREDIT, handleCreditDataUpdate);
    };
  }, []);
  const handleCredit = (data) => {
    const { credit } = data;
    const currentCoin = __.lowerCase("USDT");
    const currentCredit = forceSatoshiFormat(credit[currentCoin]);
    console.log('current credit ' +currentCredit);
    storage.setKey('credit', currentCredit);
  };
  const handleCreditUpdate = (data) => {
    console.log('update credit' + data);
    const { value, coin: updatedCoin } = data;
    const formattedValue = forceSatoshiFormat(value);
    if (__.lowerCase(updatedCoin) === __.lowerCase(selectedCoin)) {
      storage.setKey('credit', formattedValue);
    }
  };

  useEffect(() => {
    if (selectedBets?.length > 0) {
      setBetsState(selectedBets);
    } else {
      setBetsState([]);
    }
  }, [selectedBets]);

  useEffect(() => {
function normalizeOdds(odds) {
  let newodds;
  if (odds > 100) {
    // Positive American odds → decimal
    newodds = (odds / 100) + 1;       // e.g. 150 → 2.50
  } else if (odds < 100) {
    // Small odds → scale down close to 1.0
    newodds = 1 + (odds / 100);       // e.g. 2.75 → 1.0275
  } else {
    newodds = 2.0;                    // exactly 100 → 2.0
  }

  // Floor to 2 decimal places (no rounding up)
  return Math.floor(newodds * 100) / 100;
}

  const total = selectedBets.reduce((sum, bet) => {
    // guard: need stake and odds
    if (!bet || bet.stake == null || bet.odds == null) return sum;

    const stake = Number(bet.stake) || 0;
    let odds = Number(bet.odds) || 0;

    // Use normalized odds for BM game type
    if (bet.market === 'BM') {
      odds = normalizeOdds(odds);
    }

    // liability: lay uses stake*(odds-1), back uses stake
    const liability = (bet.type === 'lay') ? (stake * (odds - 1)) : stake;
    const stakel = (stake * (odds - 1))
    return sum + liability;
  }, 0);

  // keep two decimals (as string)
  setTotalLiability((Math.round(total * 100) / 100).toFixed(2));
}, [selectedBets]);

  const handleStakeChange = (value, betId) => {
    const validValue = value.replace(/[^0-9.]/g, '');
    updateBetStake(betId, validValue);

    // Update local state to reflect changes immediately
    setBetsState(prevState =>
      prevState.map(bet => {
        if (bet.id === betId) {
          const stake = parseFloat(validValue) || 0;
          const odds = parseFloat(bet.odds) || 0;
          const profit = (stake * (odds - 1)).toFixed(2);
          return {
            ...bet,
            stake: validValue,
            profit: profit
          };
        }
        return bet;
      })
    );
  };
  const handleQuickStake = (value, betId) => {
    handleStakeChange(value.toString(), betId);
  };

  const calculateProfit = (bet) => {
    if (!bet.stake || !bet.odds) return '0.00';
    const stake = parseFloat(bet.stake) || 0;
    const odds = parseFloat(bet.odds) || 0;
    return (stake * (odds - 1)).toFixed(2);
  };

  const handleOddsChange = (newOdds, betId) => {
    setBetsState(prevState =>
      prevState.map(bet => {
        if (bet.id === betId) {
          const stake = parseFloat(bet.stake) || 0;
          const odds = parseFloat(newOdds) || 0;
          const profit = (stake * (odds - 1)).toFixed(2);
          return {
            ...bet,
            odds: newOdds,
            profit: profit
          };
        }
        return bet;
      })
    );

    // Update context to reflect odds change
    updateBetOdds(betId, newOdds);
  };

  const handleCancelAll = () => {
    selectedBets.forEach(bet => removeBet(bet.id));
    setBetsState([]);
    setIsConfirmed(false);
  };

  const handlePlaceBets = async () => {
    // Prevent re-entry if a placement is already in progress
    if (isPlacing) {
      console.warn('Placement already in progress, ignoring duplicate call.');
      return;
    }

    console.log("🚀 handlePlaceBets triggered");
    console.log("Selected Bets State:", betsState);

    if (!isConfirmed) {
      console.warn("⚠️ Not confirmed yet");
      sendNotfication('Please confirm your bets before placing them.', 'error', 'bottom-left');
      return;
    }

    // set the lock
    setIsPlacing(true);


    try {
      // filter valid bets
      const validBets = betsState.filter(bet =>
        bet &&
        bet.stake != null &&
        bet.odds != null &&
        bet.stake !== '' &&
        bet.odds !== '' &&
        !isNaN(Number(bet.stake)) &&
        !isNaN(Number(bet.odds)) &&
        Number(bet.odds) > 1
      ).map(bet => ({ ...bet, stake: Number(bet.stake) }));

      console.log("✅ Valid Bets after basic filter:", validBets);

      if (validBets.length === 0) {
        console.error("❌ No valid bets found");
        sendNotfication('Please enter valid stakes and odds for your bets.', 'error', 'bottom-left');
        return;
      }

      // --- CHECK BEFORE PLACING: stake limits per bet ---
      const stakeErrors = validBets.filter(b => b.stake < MIN_STAKE || b.stake > MAX_STAKE);
      if (stakeErrors.length > 0) {
        // build helpful message listing offending selections
        const messages = stakeErrors.map(b => {
          if (b.stake < MIN_STAKE) return `"${b.selectionName}" has stake ${b.stake} (min ${MIN_STAKE})`;
          return `"${b.selectionName}" has stake ${b.stake} (max ${MAX_STAKE})`;
        });
        sendNotfication(`Stake limit error: ${messages.join('; ')}`, 'error', 'bottom-left');
        return;
      }
      // ✅ odds mismatch check
      const changedBets = validBets.filter(bet => {
        console.log(`Checking ${bet.selectionName}: initial=${bet.initialOdds}, live=${bet.liveOdds}, userInput=${bet.odds}`);
        return Number(bet.liveOdds) !== Number(bet.initialOdds);
      });

      if (changedBets.length > 0) {
        console.warn("❌ Odds mismatch detected:", changedBets);
        sendNotfication(
          `Odds have changed for: ${changedBets.map(b => b.selectionName).join(', ')}`,
          'error',
          'bottom-left'
        );
        return; // ❌ stop placing bets
      }

      console.log("✅ Odds match. Proceeding with placing bets...");

      // ✅ only if odds match, place bets
      const result = await placeBets(validBets);
      console.log("🎯 PlaceBets Result:", result);

      if (result?.confirmed?.length > 0) {
        sendNotfication('Bets placed successfully!', 'success', 'bottom-left');
      } else {
        const firstError = result?.errors?.[0]?.message || 'Bet placement failed';
        console.error("❌ Bet placement failed:", firstError);
        sendNotfication(firstError, 'error', 'bottom-left');
      }

      // If context cleared selected bets, clear local UI as well
      if ((selectedBets?.length || 0) === 0) {
        console.log("🧹 Clearing all bets after placement");
        handleCancelAll();
      }

    } catch (err) {
      // console.error('Error while placing bets:', err);
      sendNotfication('An unexpected error occurred while placing bets.', 'error', 'bottom-left');
    } finally {
      // release the lock
      setIsPlacing(false);
    }
  };


  return (
    <Container>
      <Header>
        <span>Bet Slip ({selectedBets?.length || 0})</span>
      </Header>

      {selectedBets?.length === 0 ? (
        <div style={{ padding: '8px', textAlign: 'center', color: '#ffffff', borderBottomWidth: '1px', borderBottomColor: 'rgb(50, 55, 56)', borderBottomStyle: 'solid' }}>
          No Bets
        </div>
      ) : (
        betsState.map((bet) => (
          <div key={bet.id}>
            <SubHeader>
              {bet?.type === "lay" ?
                <div>Lay (Bet Against)</div> :
                <div>Back (Bet For)</div>
              }
              <div>Odds</div>
              <div>Stake</div>
              {bet?.type === "lay" ?
                <div>Liability</div> :
                <div>Profit</div>
              }
            </SubHeader>

           <MatchTitle type={bet?.type}>
  <Dot />
  {bet?.matchTitle}
</MatchTitle>

            {bet?.type === "lay" ? (
              <>
                <BetRowContainer>
                  <TeamSection>
                    <CloseIcon onClick={() => removeBet(bet.id)}>✕</CloseIcon>
                    <TeamName>{bet.selectionName}</TeamName>
                    <MatchOdds>{bet.category}</MatchOdds>
                  </TeamSection>
                  <OddsInputContainer>
                    <StyledInput
                      type="text"
                      value={bet.odds}
                      onChange={(e) => handleOddsChange(e.target.value, bet.id)}
                      style={{ paddingRight: '20px' }}
                    />
                    
                  </OddsInputContainer>
                  <StyledInput
                    type="text"
                    value={bet.stake}
                    onChange={(e) => handleStakeChange(e.target.value, bet.id)}
                    placeholder="0"
                  />
                  <LiabilityValue>
                    {totalLiability}
                  </LiabilityValue>
                </BetRowContainer>
                <QuickStakeButtons>
                  {[100, 200, 300, 400, 500, 1000].map(value => (
                    <StakeButton key={value} onClick={() => handleQuickStake(value, bet.id)}>
                      {value}
                    </StakeButton>
                  ))}
                </QuickStakeButtons>
                <Footer>
                  <MinBetText>Min Bet: 100</MinBetText>
                </Footer>
              </>
            ) : (
              <>
                <BetRowContainerBlue>
                  <TeamSection>
                    <CloseIcon onClick={() => removeBet(bet.id)}>✕</CloseIcon>
                    <TeamName>{bet.selectionName}</TeamName>
                    <MatchOdds>{bet.category}</MatchOdds>
                  </TeamSection>
                  <OddsInputContainer>
                    <StyledInput
                      type="text"
                      value={bet.odds}
                  
                      style={{ paddingRight: '20px' }}
                    />
                  </OddsInputContainer>
                  <StyledInput
                    type="text"
                    value={bet.stake}
                    onChange={(e) => handleStakeChange(e.target.value, bet.id)}
                    placeholder="0"
                  />
                  <LiabilityValue>
                    {totalLiability}
                  </LiabilityValue>
                </BetRowContainerBlue>
                <QuickStakeButtonsBlue>
                  {[100, 200, 300, 400, 500, 1000].map(value => (
                    <StakeButton key={value} onClick={() => handleQuickStake(value, bet.id)}>
                      {value}
                    </StakeButton>
                  ))}
                </QuickStakeButtonsBlue>
                <FooterBlue>
                  <MinBetText>Min Bet: 100</MinBetText>
                </FooterBlue>
              </>
            )}
          </div>
        ))
      )}

      {selectedBets?.length > 0 && (
        <>
          <LiabilityText>Total Liability: {totalLiability}</LiabilityText>
          <ActionButtons>
            <Button1 onClick={handleCancelAll}>Cancel All</Button1>
            <Button primary onClick={handlePlaceBets} disabled={isPlacing} aria-busy={isPlacing}>
              {isPlacing ? 'Placing...' : 'Place Bets'}
            </Button>
          </ActionButtons>

          {/* <BetConfirm>
            <input
              type="checkbox"
              checked={isConfirmed}
              onChange={(e) => setIsConfirmed(e.target.checked)}
            />
            <span>Please confirm your bets.</span>
          </BetConfirm> */}
        </>
      )}
    </Container>
  );
};


export default BetSlip;
